var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62.49 66.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lag_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m0,66.95C0,42.95,0,24.05,0,0c21.68,10.64,62.5,31.44,62.49,32.83-.01,1.22-39.63,22.18-62.49,34.12Zm8.72-17.07c12.9-6.06,21.41-10.07,36.12-16.99-14.9-7.06-23.81-11.27-36.12-17.1,0,12.59,0,20.56,0,34.09Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteArrow);
export default __webpack_public_path__ + "static/media/White_Arrow.fb3eb973f225b96b1a95256d5fa5a2b7.svg";
export { ForwardRef as ReactComponent };